<template>
  <div
    class="dashboard block"
    v-if="getUserRole===1"
  >
    <el-tabs>
      <el-tab-pane label="报名进行中">
        <div
          class="tableIng"
          v-for="(item,index) in list"
          :key="index"
        >
          <!-- <span class="company-logo"><img :src="imgUrl+item.companyLogo"/></span> -->
          <span>{{item.title}}</span>
          <span><i class="el-icon-time"></i>报名开始时间:{{item.startTime}}</span>
          <span><i class="el-icon-time"></i>报名结束时间:{{item.endTime}}</span>
          <span>
            <a
              :href="'#/doSignUp/'+item.id"
              class="btn"
              v-if="item.status === 1"
            >立即报名</a>
            <a
              href="javascript:void(0)"
              class="waiting"
              v-else
            >{{item.status==0?'即将开始':item.status==1?'进行中':'已截止'}}</a>
            <a
              :href="'#/recruitDetail/'+item.id"
              class="btn"
              target="_block"
            >招聘详情</a>
          </span>

        </div>

      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {recruitRes} from '@/api'
import ApiConfig from '@/config/ApiConfig'
export default {
  data: function() {
    return {
      list: [
        // {
        //   content:
        //     "八斗金人力资源招聘八斗金人力资源招聘八斗金人力资源招聘八斗金人力资源招聘",
        //   startTime: "2018-11-12",
        //   endTime: "2018-12-12"
        // },
        // {
        //   content: "八斗金人力资源",
        //   startTime: "2018-11-12",
        //   endTime: "2018-12-12"
        // }
      ],
      pageNum:1,
      imgUrl:ApiConfig.imgUrl
    };
  },
  mounted(){
    this.loadRecruitPage()
  },
  methods:{
    loadRecruitPage(data){
      const {pageNum} = this
      recruitRes.getPage({pageNum,isRelease:1}).then(res => {
          const {records,total} = res
          this.list = records
          ++this.pageNum
      })
    }
  },
  computed: {
    ...mapGetters(["getUserRole"])
  }
};
</script>
<style lang="scss" >
.tableIng {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #e0dbdb;
  color: gray;
      align-items: center;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
    padding: 15px 0;
    font-size: small;
    &:first-of-type {
      text-align: left;
    }
  }
  .btn {
    border-radius: 4px;
    color: white;
    padding: 4px 12px;
    margin-right: 5px;
    text-decoration: underline;
    &:first-of-type {
      color: #ff7f00;
    }
    &:last-of-type {
      color: #ff7f00;
    }
  }
}
.company-logo{
  display: inline-block;
  width: 50px;
  height: 50px;
  &>img{
    max-width: 100%;
  }
}
.waiting{

}
</style>

